// AuditTrailEntry.tsx
import { clsx } from "@mantine/core";
import { FC } from "react";
import { PublishedOfferAuditTrail } from "graphql/__generated__/globalTypes";

interface AuditTrailEntryProps {
  entry: PublishedOfferAuditTrail;
  index: number;
}

const AuditTrailEntry: FC<AuditTrailEntryProps> = ({ entry, index }) => {
  const formatDateTime = (dateString?: string | null) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getActorColorClass = (actor: string) => {
    if (!actor) return "bg-gray-100 text-gray-700 border-gray-200";

    const colors = [
      "bg-blue-100 text-blue-700 border-blue-200",
      "bg-green-100 text-green-700 border-green-200",
      "bg-purple-100 text-purple-700 border-purple-200",
      "bg-orange-100 text-orange-700 border-orange-200",
      "bg-pink-100 text-pink-700 border-pink-200",
      "bg-indigo-100 text-indigo-700 border-indigo-200",
      "bg-cyan-100 text-cyan-700 border-cyan-200",
      "bg-emerald-100 text-emerald-700 border-emerald-200",
    ];

    let hash = 0;
    for (let i = 0; i < actor.length; i++) {
      hash = ((hash << 5) - hash + actor.charCodeAt(i)) & 0xffffffff;
    }

    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <span
              className={clsx(
                "inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border",
                getActorColorClass(entry?.actor || "N/A")
              )}
            >
              {entry?.actor || "Unknown"}
            </span>
            <span className="text-xs text-gray-500">
              {formatDateTime(entry?.created_at)}
            </span>
          </div>
          <p className="text-sm text-gray-800 leading-relaxed">
            {entry?.action}
          </p>
        </div>
        <div className="ml-4 flex-shrink-0">
          <span className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
            {index + 1}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AuditTrailEntry;
